module.exports = __webpack_public_path__ + "img/42.a95ba74a.jpg";